import React from "react"

import Layout from "../components/en/Layout"

const AboutPage = props => (
  <Layout>
    <h1>Start &#128587;</h1>
    <p>
      Enter your e-mail and password to connect. If you don't have an account,
      choose <strong>Create account</strong> enter your e-mail, name and
      password. You will receive a confirmation code by e-mail.
    </p>
    <p>
      After connectiong, you can use it freely. The option{" "}
      <strong>How it works</strong> shows a simple help text and the option{" "}
      <strong>Start</strong> leads to the main screen.
    </p>
    <p>
      The icon &#9776; at the upper right coener of the screen opens a side menu
      at the left that contains many of the application functions:
    </p>
    <p>
      <ul>
        <li>
          <strong>Persona data</strong> - Your photo and personal data;
        </li>
        <li>
          <strong>Guardians</strong> - Registration of guardians. You can
          register here all animals that you have put for adoption and they will
          be grouped over your account, making it easy to reach anyone who wants
          to adopt;
        </li>
        <li>
          <strong>Adoption records</strong> - Any adoptions you make as donor
          are registered here;
        </li>
        <li>
          <strong>Adopted animals</strong> - Shows all the animals that were
          registered as adopted;
        </li>
        <li>
          <strong>Global search</strong> - Allows you to perform general
          searches of animals in your area by physical characteristics;
        </li>
        <li>
          <strong>Summary</strong> - Shows totals by region and situation;
        </li>
        <li>
          <strong>Preferences</strong> - Application Usage Options;
        </li>
        <li>
          <strong>Change password</strong> - Allows you to change your password;
        </li>
        <li>
          <strong>Desativar conta</strong> - If you no longer want to use the
          app, you can delete your account here;
        </li>
      </ul>
    </p>
  </Layout>
)

export default AboutPage
